import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'modal',
  standalone: false,
})
export class WlModalBodyScrollToTopDirective {
  /**
   * bind do modal's onOpen event
   */
  @HostListener('onOpen') public onModalOpen(): void {
    this.scrollBodyToTop();
  }

  /**
   * injection please
   * @param _modal
   * @param _element
   */
  constructor(public _element: ElementRef) {}

  /**
   * scroll the body content to the top
   */
  public scrollBodyToTop(): void {
    if (!this._element || !this._element.nativeElement) return;

    let modalControlElement: HTMLDivElement = <HTMLDivElement>this._element.nativeElement;

    // this is where the scrollbars are
    let bodyElement: Element = modalControlElement.querySelector('.modal-body');
    let wlTabBodyElement: Element = modalControlElement.querySelector('.wl-tab-content-container');

    if (bodyElement) bodyElement.scrollTop = 0;

    if (wlTabBodyElement) wlTabBodyElement.scrollTop = 0;
  }
}
